module.exports = __webpack_public_path__ + "static/media/metamask-wallet.825539d9.svg";